export const defined = <T extends Record<string, unknown>>(
  obj: T,
): { [key in keyof T]?: string } => {
  const newObj: { [key in keyof T]?: string } = {};
  for (const key in obj) {
    if (typeof obj[key] !== "undefined" && obj[key] !== null) {
      newObj[key] = String(obj[key]);
    }
  }
  return newObj;
};
